import { createAsyncThunk, nanoid } from '@reduxjs/toolkit';
import { entries } from 'lodash';
import { getStore } from '~store/store';

import { createModal, removeModal } from './reducer';
import { IModal, ModalCloseReason, ModalType } from '@qodly/shared';

interface IOpenModalPayload extends Omit<IModal, 'id' | 'isOpen' | 'type'> {
  type?: ModalType;
}

interface IOpenModalReturnValue {
  confirmed?: boolean;
  options?: Record<string, boolean>;
}

export const openModal = createAsyncThunk<
  IOpenModalReturnValue,
  IOpenModalPayload
>('modals/open', async (payload: IOpenModalPayload, { dispatch }) => {
  const store = getStore();
  const { type = ModalType.ALERT } = payload;
  const id = nanoid();

  dispatch(
    createModal({
      id,
      type,
      isOpen: true,
      ...payload,
    }),
  );
  switch (type) {
    case ModalType.CONFIRM:
      return new Promise((resolve) => {
        const unsubscribe = store.subscribe(() => {
          const { modals } = store.getState();
          const found = modals.list.find((modal) => modal.id === id);

          if (found && !found.isOpen) {
            const confirmed = found.closeReason === ModalCloseReason.CONFIRMED;
            const options = entries(found.views?.toggles).reduce(
              (acc, curr) => ({
                ...acc,
                [curr[0]]: curr[1].value,
              }),
              {},
            );
            dispatch(removeModal(id));
            unsubscribe();

            resolve({ confirmed, options });
          }
        });
      });
    default:
      return {};
  }
});
